import React, { createContext, useContext, useMemo } from 'react';
import { useCurrentFrame } from 'remotion';
import { SegmentBoundaryTransition } from '@goldcast/player-config/src/types/RemotionPlayerConfigTypes/Track/SegmentTransition';
import { getSegmentTransitionVolumeMultiplier } from '@/App/remotion/libs/transitions/segmentTransition/utils';

type SegmentTransitionVolumeProviderProps = {
  segmentDurationInFrames: number;
  incomingTransition?: SegmentBoundaryTransition | null;
  outgoingTransition?: SegmentBoundaryTransition | null;
  children: React.ReactNode;
};

export const SegmentTransitionVolumeContext = createContext<number>(1);

export function useSegmentTransitionVolume(): number {
  return useContext(SegmentTransitionVolumeContext);
}

export function SegmentTransitionVolumeProvider({
  segmentDurationInFrames,
  incomingTransition,
  outgoingTransition,
  children
}: SegmentTransitionVolumeProviderProps): React.ReactElement {
  const segmentRelativeFrame = useCurrentFrame();
  const multiplier = useMemo(
    () =>
      getSegmentTransitionVolumeMultiplier(
        segmentRelativeFrame,
        segmentDurationInFrames,
        incomingTransition,
        outgoingTransition
      ),
    [segmentRelativeFrame, segmentDurationInFrames, incomingTransition, outgoingTransition]
  );

  return (
    <SegmentTransitionVolumeContext.Provider value={multiplier}>{children}</SegmentTransitionVolumeContext.Provider>
  );
}
